var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._l(_vm.not_menu_pages, function (page) {
    return _c('ReportMenuItem', {
      key: page.title,
      attrs: {
        "child": page,
        "show_favorite_button": false
      }
    });
  }), _vm._v(" "), _c('ReportMenu', {
    attrs: {
      "menu-data": {
        title: _vm.$t('frequently_used_reports')
      },
      "show_favorite_button": false,
      "reports": _vm.frequently_used_reports
    },
    on: {
      "favorite_reports_changed": _vm.update_favorite_reports
    }
  }), _vm._v(" "), _c('ReportMenu', {
    attrs: {
      "menu-data": {
        title: _vm.$t('can_reports')
      },
      "show_favorite_button": true,
      "reports": _vm.can_reports
    },
    on: {
      "favorite_reports_changed": _vm.update_favorite_reports
    }
  }), _vm._v(" "), _c('ReportMenu', {
    attrs: {
      "menu-data": {
        title: _vm.$t('reports')
      },
      "show_favorite_button": true,
      "reports": _vm.reports
    },
    on: {
      "favorite_reports_changed": _vm.update_favorite_reports
    }
  }), _vm._v(" "), _c('ReportMenu', {
    attrs: {
      "menu-data": {
        title: _vm.$t('automatic_reporting')
      },
      "show_favorite_button": false,
      "reports": _vm.auto_reports
    },
    on: {
      "favorite_reports_changed": _vm.update_favorite_reports
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }